import React from 'react'
import { useForm } from 'react-hook-form'
import { Button, Box, Typography } from '@mui/material'
import { api } from 'services'
import { useSnackbar } from 'notistack'

export default function DeleteReportForm ({ id, title, closeModalFunction, exitFunction }) {
  const { enqueueSnackbar } = useSnackbar()
  const { handleSubmit } = useForm()

  // Form Submission Handling
  const onSubmit = (data) => {
    if (id) {
      api.reports
        .delete(id)
        .then(function (response) {
          enqueueSnackbar('Report has been deleted.', {
            variant: 'success',
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'center'
            }
          })
          if (closeModalFunction) closeModalFunction()
          exitFunction(true)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
  return (
    <form id="delete_report_form" onSubmit={handleSubmit(onSubmit)}>
      <Box display="flex" flexDirection="row" justifyContent="flex-start">
        <Box flexGrow={1}>
          <Typography variant="subtitle1" color="error">
            {`Are you sure you want to delete ${title}?`}
          </Typography>
        </Box>
        <Box pr={2}>
          <Button type="submit" variant="contained" color="error" size="small">
            {'Delete Report'}
          </Button>
        </Box>
        <Button color="primary" variant='contained' size="small" onClick={closeModalFunction}>
          {'Cancel'}
        </Button>
      </Box>
    </form>
  )
}
